import React from "react";
import { NavLink } from "react-router-dom";
import './Logo.scss'

function Logo({variant, link=true}) {
  const logo=<div className={'logo logo-bb'+(variant ? ' logo-'+variant : '')}>
  </div>;
  return link ? <NavLink to={'/'}>{logo}</NavLink> : logo;
}
export default Logo;
